import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Content from '../components/layout/content/index.vue'
import City from '../views/Citys.vue'
import Jobs from '../views/Jobs.vue'
import About from '../views/about.vue'
import HeaderMenu from '../views/HeaderMenu.vue'
import NewHome from '../views/NewHome.vue'
import AboutXc from '../views/AboutXc.vue'
import ContactUs from '../views/ContactUs.vue'
import LaborRelations from '../views/LaborRelations.vue'
import OverseasColumn from '../views/OverseasColumn.vue'
import LegalInfo from '../views/LegalInfo.vue'
import i18n from '../i18n'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    children: [
      {
        path: '/',
        name: 'IndexHome',
        component: NewHome,
      },
      {
        path: '/home/jobs',
        name: 'jobs',
        component: Jobs,
      },
      {
        path: '/home/index',
        name: 'IndexLegacy',
        component: Content,
      },
      {
        path: '/home/product-detail',
        name: 'ProductDetail',
        component: Content,
      },
      {
        path: '/home/citys',
        name: 'City',
        component: City,
      },
      {
        path: '/home/about-xc',
        name: 'AboutXc',
        component: AboutXc,
      },
      {
        path: '/home/menu',
        name: 'HeaderMenu',
        component: HeaderMenu,
      },
      {
        path: '/home/contact-us',
        name: 'ContactUs',
        component: ContactUs,
      },
      {
        path: '/home/labor-relations',
        name: 'LaborRelations',
        component: LaborRelations,
      },
      {
        path: '/home/overseas-column',
        name: 'OverseasColumn',
        component: OverseasColumn,
      },
      {
        path: '/home/legal-info',
        name: 'LegalInfo',
        component: LegalInfo,
      }
    ]
  },
  {
    path: '/home',
    name: 'HomeAlias',
    component: Home,
    children: [
      {
        path: '/',
        name: 'IndexHomeAlias',
        component: NewHome,
      },
      {
        path: '/home/index',
        name: 'IndexLegacyAlias',
        component: Content,
      },
      {
        path: '/home/product-detail',
        name: 'ProductDetailAlias',
        component: Content,
      },
      {
        path: '/home/citys',
        name: 'CityAlias',
        component: City,
      },
      {
        path: '/home/jobs',
        name: 'JobsAlias',
        component: Jobs,
      },
      {
        path: '/home/about',
        name: 'AboutAlias',
        component: About,
      },
      {
        path: '/home/about-xc',
        name: 'AboutXcAlias',
        component: AboutXc,
      },
      {
        path: '/home/menu',
        name: 'HeaderMenuAlias',
        component: HeaderMenu,
      },
      {
        path: '/home/contact-us',
        name: 'ContactUsAlias',
        component: ContactUs,
      },
      {
        path: '/home/labor-relations',
        name: 'LaborRelationsAlias',
        component: LaborRelations,
      },
      {
        path: '/home/overseas-column',
        name: 'OverseasColumnAlias',
        component: OverseasColumn,
      },
      {
        path: '/home/legal-info',
        name: 'LegalInfoAlias',
        component: LegalInfo,
      }
    ]
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, _from, next) => {
  const supportedLocales = ['zh-CN', 'en', 'vi']
  const queryLang = to.query.lang
  const savedLang = localStorage.getItem('locale')

  console.log('[router beforeEach] enter', {
    to: to.fullPath,
    queryLang,
    savedLang,
    currentLocale: i18n.locale
  })

  const normalizedSavedLang = supportedLocales.includes(savedLang) ? savedLang : 'zh-CN'
  const normalizedCurrentLang = supportedLocales.includes(i18n.locale) ? i18n.locale : normalizedSavedLang

  if (supportedLocales.includes(queryLang)) {
    if (i18n.locale !== queryLang) {
      console.log('[router beforeEach] set locale from query', {
        from: i18n.locale,
        to: queryLang
      })
      i18n.locale = queryLang
    }
    localStorage.setItem('locale', queryLang)
    console.log('[router beforeEach] exit by query', {
      finalLocale: i18n.locale,
      saved: localStorage.getItem('locale')
    })
    next()
    return
  }

  if (i18n.locale !== normalizedCurrentLang) {
    console.log('[router beforeEach] fallback locale sync', {
      from: i18n.locale,
      to: normalizedCurrentLang
    })
    i18n.locale = normalizedCurrentLang
  }

  console.log('[router beforeEach] exit fallback', {
    finalLocale: i18n.locale,
    saved: localStorage.getItem('locale')
  })
  localStorage.setItem('locale', normalizedCurrentLang)

  next({
    path: to.path,
    params: to.params,
    query: { ...to.query, lang: normalizedCurrentLang },
    hash: to.hash,
    replace: true
  })
})

export default router
